import InsightsFeaturedCard from './InsightsFeaturedCard';

export { type InsightsFeaturedCardProps } from './InsightsFeaturedCard';
export default InsightsFeaturedCard;
